import { HttpErrorResponse } from '@angular/common/http';

function hasMeaningfulErrorPayload(errorPayload: unknown): boolean {
  if (errorPayload == null) {
    return false;
  }

  if (typeof errorPayload === 'string') {
    return errorPayload.trim().length > 0;
  }

  if (errorPayload instanceof Blob) {
    return errorPayload.size > 0;
  }

  if (errorPayload instanceof ArrayBuffer) {
    return errorPayload.byteLength > 0;
  }

  if (errorPayload instanceof ProgressEvent) {
    return false;
  }

  if (typeof errorPayload === 'object') {
    return Object.keys(errorPayload as Record<string, unknown>).length > 0;
  }

  return true;
}

export function isReachableProbeResponse(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse)) {
    return false;
  }

  if (error.status <= 0) {
    return false;
  }

  // Keep explicit auth statuses reachable even when body-less.
  if (error.status === 401 || error.status === 403) {
    return true;
  }

  // Separate gateway/upstream failures from real backend 5xx replies.
  if (error.status >= 500) {
    return hasMeaningfulErrorPayload(error.error);
  }

  return true;
}
